<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";

  export let icon: string;
  export let title: string;
  export let description: string;
  export let customIcon: boolean = false;
</script>

<style lang="scss">
  .info-card {
    display: flex;
    align-items: flex-start;

    &--icon {
      margin-right: 12px;
    }

    &--title {
      padding: 4px 0 8px 0;
    }

    &--description {
      max-width: 282px;
    }
  }
</style>

<div class="info-card">
  <div class="info-card--icon">
    <Icon
      {icon}
      {customIcon}
      color="var(--on-background)"
      iconStyle="outline"
      lazyLoad={true}
    />
  </div>
  <div class="info-card--text">
    <div class="info-card--title">
      <Typography component="span" variant="overline">{title}</Typography>
    </div>

    <div class="info-card--description">
      <Typography component="p" variant="body1">{description}</Typography>
    </div>
  </div>
</div>
